import React from 'react';
import FormField from './FormField';

/**
 * @typedef IProps
 * @property {string} value
 * @property {React.Dispatch<string>} setValue
 *
 * @param {IProps} props
 */
export default function InputAddress1({ value, setValue }) {
  return (
    <FormField
      label="ที่อยู่สถานประกอบการ"
      placeholder="ที่อยู่บรรทัดที่ 1"
      value={value}
      onChange={(e) => setValue(e.target.value)}
    />
  );
}
